import { MessageOutlined } from '@ant-design/icons';
import caregiversNoAi from 'assets/caregivers-no-ai.png';
import { Button } from 'components/ui/button';
import { Card, CardContent, CardFooter } from 'components/ui/card';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';

/**
 * Every category page and empty search ends on a human: a thin page leads to
 * a conversation with a midwife rather than a dead end.
 */
export default function AskMidwifeCard({ source }: { source: string }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Card data-testid="ask-midwife-card">
      <CardContent className="flex items-center gap-3.5">
        <img src={caregiversNoAi} alt="" className="h-13 shrink-0" />
        <div className="flex min-w-0 flex-col gap-0.5">
          <h4>{t('infoPage.structure.askMidwife.title')}</h4>
          <p className="text-sm text-muted-foreground">{t('infoPage.article.chatCallToAction.description')}</p>
        </div>
      </CardContent>
      <CardFooter>
        <Button
          size="xl"
          className="w-full"
          onClick={() => {
            posthog.capture('info.ask_midwife_clicked', { source });
            navigate(routes.messagingHome.route);
          }}
        >
          <MessageOutlined /> {t('infoPage.structure.askMidwife.button')}
        </Button>
      </CardFooter>
    </Card>
  );
}
